export default "/assets/images/wcf-v2.9bdab87df31897b9.png";